import { createContext, Context, useContext } from 'react';
import { KeyValueStore } from './KeyValueStore.ts';
import { RawLocalState, rawLocalStateNames } from './State.tsx';
import { PuzzleIndex } from './PuzzleIndex.tsx';
import { SupabaseClient } from '@supabase/supabase-js';
import { RCAdapter } from './RcAdapter.ts';

export async function loadState(store: KeyValueStore): Promise<RawLocalState> {
    const map = await store.getItems(rawLocalStateNames);
    const pairs = rawLocalStateNames.map((key) => [key, map.get(key)] as const);
    return Object.fromEntries(pairs) as RawLocalState;
}

export const RawLocalStateContext: Context<RawLocalState | undefined> = createContext<RawLocalState | undefined>(
    undefined,
);

export function useRawLocalState(): RawLocalState {
    const ctx = useContext(RawLocalStateContext);
    if (!ctx) throw new Error('useRawGlobalState must be used within a RawGlobalStateContext.Provider');
    return ctx;
}

export const KeyValueStoreContext = createContext<KeyValueStore | undefined>(undefined);

export function useKeyValueStore(): KeyValueStore {
    const ctx = useContext(KeyValueStoreContext);
    if (!ctx) throw new Error('useKeyValueStore must be used within a KeyValueStoreContext.Provider');
    return ctx;
}

export const SupabaseClientContext = createContext<SupabaseClient | undefined>(undefined);
export function useSupabaseClient(): SupabaseClient {
    const ctx = useContext(SupabaseClientContext);
    if (!ctx) {
        throw new Error('useSupabaseClient must be used within a SupabaseClientContext.Provider');
    }
    return ctx;
}

export const RcAdapterContext = createContext<RCAdapter | undefined>(undefined);
export function useRcAdapter(): RCAdapter {
    const ctx = useContext(RcAdapterContext);
    if (!ctx) {
        throw new Error('useRcAdapter must be used within a RcAdapterContext.Provider');
    }
    return ctx;
}
